import { render, staticRenderFns } from "./La3.vue?vue&type=template&id=40dafdc0&scoped=true&"
import script from "./La3.vue?vue&type=script&lang=js&"
export * from "./La3.vue?vue&type=script&lang=js&"
import style0 from "./La3.vue?vue&type=style&index=0&id=40dafdc0&prod&lang=scss&scoped=true&"
import style1 from "./La3.vue?vue&type=style&index=1&id=40dafdc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40dafdc0",
  null
  
)

export default component.exports